import { createReducer } from 'redux-act';

import {
  MEMBERS_CLEAN_UP,
  MEMBERS_FETCH_DATA_FAIL,
  MEMBERS_FETCH_DATA_INIT,
  MEMBERS_FETCH_DATA_SUCCESS,
} from 'state/actions/members';

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const membersReducer = createReducer(
  {
    [MEMBERS_FETCH_DATA_INIT]: () => ({
      ...initialState,
      loading: true,
    }),
    [MEMBERS_FETCH_DATA_SUCCESS]: (state, payload) => ({
      ...state,
      data: payload.data,
      loading: false,
      error: null,
    }),
    [MEMBERS_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [MEMBERS_CLEAN_UP]: () => ({
      ...initialState,
    }),
  },
  initialState
);
